<template>
  <div class="pictureUpload">
    <el-upload
      ref="upload"
      list-type="picture-card"
      :format="['jpg', 'jpeg', 'png']"
      accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
      :limit="limit"
      :action="uploadHost"
      :data="uploadData"
      :file-list="fileList"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
      :class="[fileList.length >= limit && 'hide']"
      :disabled="isDisabled"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-image-viewer v-if="isShow" :on-close="closeImgViewer" :url-list="[imgUrl]"></el-image-viewer>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    maxSize: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      // hideUpload: false,
      uploadHost: "",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      fileList: [],
      isShow: false,
      imgUrl: ''
    };
  },
  watch: {
    value: {
      handler(to) {
        this.fileList = to;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 上传前的回调函数
    beforeUpload(file) {
      if (this.maxSize && file.size > (this.maxSize * 1048576)) {
        this.$message.success(`文件大小不要超过${this.maxSize}M!`)
        return false
      }
      return oss(file.name, 0, '').then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
      });
    },
    // 上传成功的回调函数
    handleSuccess(response, file, fileList) {
      // 获取公有链接
      getpublicImgUrl(this.fileData.fileName).then((res) => {
        if (res.code === 0) {
          file.url = res.data;
          this.fileList.push(file);
          this.$emit("input", this.fileList);
        } else {
          this.$message.success("获取图片链接失败");
        }
      });
    },
    // 图片删除
    handleRemove(file, fileList) {
      let data = this.fileList.filter((value, index) => {
        return value.url !== file.url;
      });
      this.fileList = data;
      this.$emit("input", this.fileList);
    },
    // 超出个数
    handleExceed() {
      this.$message({
        message: `最多上传${this.limit}张图片！`,
        type: "warning",
      });
    },
    handlePictureCardPreview(file) {
      this.imgUrl = file.url
      this.isShow = true
    },
    closeImgViewer() {
      this.isShow = false
    }
  },
};
</script>

<style lang="scss" scoped>
.pictureUpload {
  ::v-deep {
    .hide .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
